import type { AysCodeResponse } from './code.model';
import { AysCode } from './code.model';
import { AysDrgSpecificCode } from '../drg';
import { AysIcdSpecificCode } from '../icd';
import { AysCodeGroup } from './code-group.model';
import type { AysCodeCodingSystem } from './code-type.model';

export class AysCodes {
  public static summary(
    codingSystem: AysCodeCodingSystem,
    codes: AysCode[],
  ): string {
    if (codes.length === 0) {
      return `Alle ${codingSystem} Kapitel`;
    }

    function codeDisplayPrefix(code: AysCode): string {
      switch (code.hierarchyElementType) {
        case 'chapter': {
          return 'Kapitel';
        }
        case 'block': {
          return 'Gruppe';
        }
        default: {
          return '';
        }
      }
    }

    function codeSortValue(code: AysCode): number {
      switch (code.hierarchyElementType) {
        case 'chapter': {
          return 3;
        }
        case 'block': {
          return 2;
        }
        default: {
          return 1;
        }
      }
    }

    if (codes.length === 1) {
      return `${codeDisplayPrefix(codes[0])} ${codes[0].name}`;
    }

    const biggestCode = codes.sort(
      (a, b) => codeSortValue(b) - codeSortValue(a),
    )[0];
    return `${codeDisplayPrefix(biggestCode)} ${biggestCode.name} + ${codes.length - 1} weitere`;
  }

  public static fromObject(
    obj: AysCodeResponse | AysDrgSpecificCode | AysIcdSpecificCode,
  ): AysCode {
    let code: AysCode;

    switch (obj.hierarchyElementType) {
      case 'chapter':
      case 'block':
        code = AysCodeGroup.fromObject(obj);
        break;
      case 'specific': {
        switch (obj.codingSystem) {
          case 'G-DRG': {
            code = AysDrgSpecificCode.fromObject(obj);
            break;
          }
          case 'ICD-10-GM':
          case 'ICD-10-AT':
          case 'ICD-10-UK':
            code = AysIcdSpecificCode.fromObject(obj);
            break;
          default:
            code = AysCode.fromObject(obj);
        }
      }
    }

    return code;
  }
}
